// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){

	let form_id_134 = document.querySelector( "#form_id-134" );
	let id_5_134 = document.querySelector( "#id_5_134" );
	let sendto_134 = document.querySelector( "#sendto_134" );

	if (form_id_134) {
		form_id_134.addEventListener( "submit", () => {
			if( id_5_134.value == "The Club at London Marriott Hotel Park Lane" ){
				sendto_134.value = "mhrs.lonpl.theclub@marriotthotels.com";
			}
		} )
	}

	//mobile burger menu
	if(document.getElementsByClassName('js-menu-burger').length > 0){
		document.getElementsByClassName('js-menu-burger')[0].addEventListener('click', function(e){
			e.preventDefault();
			if(document.getElementById('primary-nav').classList.contains('open')){
				document.getElementById('primary-nav').classList.remove('open');
				this.classList.remove('open')
			} else {
				document.getElementById('primary-nav').classList.add('open');
				this.classList.add('open')
			}
		})
	}
	window.onload = function() {
		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.getElementById('header').classList.add('down');
		}
	};

	if(document.getElementById('filterCta')){
		document.getElementById('filterCta').addEventListener('click', function(){
			if(this.classList.contains('open')){
				this.classList.remove('open');
				document.getElementById('filterItems').classList.remove('open')
			} else {
				this.classList.add('open');
				document.getElementById('filterItems').classList.add('open')
			}
		})
	}

}());
function scrollW(){

	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		
		// downscroll code
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}